export const endpointUri =
  process.env.SERVER_URI || "https://adventurekeep-server.herokuapp.com/"

export const getToken = () => {
  const token = global?.window?.localStorage?.getItem("token")
  return token ? `Bearer ${token}` : ""
}
